<template>
  <proofreading-waiting slot="main" :novel-id="novelId" />
</template>

<script lang="ts">
import Vue from "vue";
import ProofreadingWaiting from "@/components/organisms/proofreading/ProofreadingWaiting.vue";

export default Vue.extend({
  metaInfo: {
    meta: [{ name: "robots", content: "none" }],
  },
  components: { ProofreadingWaiting },
  props: {
    novelId: String,
  },
});
</script>
